var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.handlerComponent,{tag:"component",attrs:{"name":_vm.name,"human-name":_vm.humanName,"searchables":_vm.searchables,"url-arg":_vm.urlArg,"size":_vm.size}})}
var staticRenderFns = []

export { render, staticRenderFns }